import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUpRightFromSquare } from "@fortawesome/free-solid-svg-icons";
import { modifyColor } from "../utils/helpers";
import SetFileIcon from "./setFileIcon";

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  background: ${({ theme }) => theme.colors.white};
  border: 1px solid #d0d0d0;
  padding: 1rem;
  margin-bottom: 1rem;
  font-family: ${({ theme }) => theme.fontLinks.fontFamily};
  margin: 0.5rem 0;
  flex-direction: column;
  border-radius: 5px;
  box-shadow: 3px 4px 10px 5px rgb(0 0 0 / 5%);

  a,
  span {
    text-decoration: none;
    font-weight: 600;
    margin-left: 1rem;
    color: ${({ theme }) => theme.colors.black};
    font-family: ${({ theme }) => theme.fontLinks.fontFamily};
    display: flex;
    align-items: center;
  }
  a {
    transition: all 0.5s ease;
    @media (hover: hover) {
      &:hover {
        text-decoration: underline;
      }
    }
  }
`;
const ButtonDownloadDiv = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;
const DownloadButton = styled.a`
  padding: 9px 25px 7px 25px;
  background: ${({ theme }) => theme.colors.primary};
  color: #fff !important;
  font-weight: 300 !important;
  border-radius: 5px;
  transition: all 0.5s ease;
  margin-left: 0 !important;
  max-width: 114px;
  white-space: nowrap;
  @media (hover: hover) {
    &:hover {
      background-color: ${({ theme }) => modifyColor(theme.colors.primary, 20)};
      text-decoration: none !important;
    }
  }
`;
const StyledIcon = styled(FontAwesomeIcon)`
  color: ${({ theme }) => theme.colors.primary};
`;
const OpenInNewWindow = styled.a`
  width: 100%;
`;
const ArchiveContent = styled.div`
  padding: 1rem;
  & a {
    padding: 10px;
    border-bottom: 1px solid #d0d0d0;
    font-size: 0.8rem;
    &:last-child {
      border-bottom: none;
    }
  }
  & a,
  svg {
    margin-right: 1rem;
  }
`;

const FileDownload = ({
  url,
  showDownloadButton,
  fileName,
  downloadButtonText,
  mediaItem,
}) => {
  const showArchive = mediaItem?.archiveContents ? (
    <ArchiveContent>
      {mediaItem.archiveContents.map((file, key) =>
        file.size !== "0 B" ? (
          <OpenInNewWindow
            key={key}
            href={file.url}
            target="_blank"
            rel="noreferrer"
          >
            <SetFileIcon url={file.url} />
            {file.name.split("/").slice(-1)}
          </OpenInNewWindow>
        ) : null
      )}
    </ArchiveContent>
  ) : null;
  return (
    <Wrapper>
      <span>
        {<SetFileIcon url={url} />}
        {showDownloadButton == false ? (
          <>
            <OpenInNewWindow
              href={url}
              download
              target="_blank"
              rel="noreferrer"
            >
              {fileName}
            </OpenInNewWindow>
            {!url.match(/\.zip$/i) ? (
              <StyledIcon icon={faArrowUpRightFromSquare} size="1x" />
            ) : null}
          </>
        ) : (
          <ButtonDownloadDiv>
            <span>{fileName}</span>
            <DownloadButton download href={url}>
              {downloadButtonText}
            </DownloadButton>
          </ButtonDownloadDiv>
        )}
      </span>
      {showArchive}
    </Wrapper>
  );
};

FileDownload.propTypes = {
  fileName: PropTypes.string,
  url: PropTypes.string,
  showDownloadButton: PropTypes.bool,
  downloadButtonText: PropTypes.string,
  mediaItem: PropTypes.shape({
    archiveContents: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        url: PropTypes.string,
        size: PropTypes.string,
      })
    ),
  }),
};

export default FileDownload;
